






































































import { Component, Prop, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import { BbsApi } from "@/api/bbsApi";

@Component({
  components: {
    Header,
    Footer,
  },
})
export default class BbsList extends Vue {
  bbsApi = new BbsApi();
  orderColumn = "ID";
  dataList: Array<object> = [];
  pageNum = 1;
  listTotal = 0;
  searchKey = "";

  mounted() {
    this.getDataList();
  }

  search() {
    this.pageNum = 1;
    this.getDataList();
  }

  changeTab(tabIdx: string) {
    this.orderColumn = tabIdx;
  }
  getDataList() {
    this.bbsApi
      .getBbsList(this.pageNum, 10, this.searchKey, this.orderColumn)
      .then((res) => {
        this.dataList = res.data;
        this.listTotal = res.total;
      });
  }

  changeListPage(page: number, pageSize: number) {
    this.pageNum = page;
    this.getDataList();
  }
}
